<template>
  <div class="paper_page" v-loading="loading" element-loading-text="加载中，请稍候···" element-loading-custom-class="loading_color" element-loading-spinner="el-icon-loading">
    <div class="header_paper" id="header_paper">
      <div class="logo_paper">
        <img src="@/assets/images/header/logo.png" alt />
      </div>
      <div class="paper_name">{{paper.pname}}</div>
    </div>
    <div class="bread" id="bread">
      <template v-if="model != 'client'">
        <router-link class="first" to="/" tag="span">首页/</router-link>
        <router-link to="/my_evaluation" tag="span">个人中心/</router-link>
        <router-link to="/my-personal/evaluation_record" tag="span">测评记录/</router-link>
        <span>测评详情</span>
      </template>
      <div class="test_info" style="margin-left: 5px">
        <div class="question_info">
          <span class="text">已作答/总题数：</span>
          <span class="value">
            <b style="color:#ff9978;font-size:24px">{{answer_count}}</b>
            /{{question_num}}
          </span>
        </div>

        <div class="test_time">
          <span class="text">得分：</span>
          <span class="value">{{self_score}} / {{ allscore }}</span>
        </div>

        <div class="test_time">
          <span class="text">作答时间：</span>
          <span class="value">{{answer_time}}</span>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="paper">
        <!--遍历顺序 :  1.子卷 2.大题3.题-->
        <div v-if="paper.gkPapers != null">
          <div v-for="(child_paper,index) in paper.gkPapers" :key="index">
            <childPaper :child-paper="child_paper" :self-assessment="selfAssessment" :set-disabled="setDisabled"></childPaper>
          </div>
        </div>

        <div v-else>
          <div v-if="paper.gkBigQuestions != null">
            <div v-for="(bigQuestion,index) in paper.gkBigQuestions" :key="index">
              <bigQuestion :big-question="bigQuestion" :self-assessment="selfAssessment" :set-disabled="setDisabled"></bigQuestion>
            </div>
          </div>
          <div v-else>
            <!-- A => 单选 B => 多选 C => 判断 M => 复合题 E => 填空 S => 解答 -->
            <div v-for="(question,index) in paper.gkQuestions" :key="index">
              <div v-if="questoin.typeCode == 'M' ">
                <compositeQuestion :question="questoin" :self-assessment="selfAssessment" :set-disabled="setDisabled"></compositeQuestion>
              </div>
              <div v-if="questoin.typeCode == 'A'">
                <radioQuestion :question="questoin" :self-assessment="selfAssessment" :set-disabled="setDisabled"></radioQuestion>
              </div>
              <div v-if="questoin.typeCode == 'B'">
                <multiQuestion :question="questoin" :self-assessment="selfAssessment" :set-disabled="setDisabled"></multiQuestion>
              </div>
              <div v-if="questoin.typeCode == 'C'">
                <judgeQuestion :question="questoin" :self-assessment="selfAssessment" :set-disabled="setDisabled"></judgeQuestion>
              </div>
              <div v-if="questoin.typeCode == 'E'">
                <fillBlankQuestion :question="questoin" :self-assessment="selfAssessment" :set-disabled="setDisabled"></fillBlankQuestion>
              </div>
              <div v-if="questoin.typeCode == 'S'">
                <solutionQuestion :question="questoin" :self-assessment="selfAssessment" :set-disabled="setDisabled"></solutionQuestion>
              </div>
            </div>
            <!--  -->
          </div>
        </div>
      </div>

      <!-- questions -->
      <div class="aside" v-if="asShow">
        <questionCard :question-status="questionStatus" :question-submit-info="questionSubmitInfo" :answer-count="answer_count"></questionCard>
      </div>
      <!-- aside -->
    </div>
    <!-- main -->
  </div>
  <!-- paper -->
</template>

<script>
import questionCard from "../evaluation_record/card.vue";
// import radioQuestion from "@/components/paper/question/concrete_question/radio_question";
// import judgeQuestion from "@/components/paper/question/concrete_question/judge_question";
// import fillBlankQuestion from "@/components/paper/question/concrete_question/fillblank_question";
// import multiQuestion from "@/components/paper/question/concrete_question/multi_question";
// import solutionQuestion from "@/components/paper/question/concrete_question/solution_question";
// import compositeQuestion from "@/components/paper/question/concrete_question/composite_question";
import bigQuestion from "@/components/paper/question/question/big_question";
import childPaper from "@/components/paper/child_paper/child_paper";

export default {
  name: "paper",
  components: {
    questionCard,
    radioQuestion,
    judgeQuestion,
    fillBlankQuestion,
    multiQuestion,
    solutionQuestion,
    compositeQuestion,
    bigQuestion,
    childPaper,
  },
  data() {
    return {
      model: '',
      //记时使用
      answer_time: 0, //考试时间
      question_num: 0,
      count_down: "00:00:00", //记时显示用
      out_time: "00:00:00", //超时时间
      self_score: 0,
      allscore: 0,
      //试卷信息
      paper: {},
      //问题id数组
      qnArray: [],
      questionStatus: [], //题的状态
      //提交的试卷信息
      questionSubmitInfo: {},
      test_id: 0,
      answer_count: 0,
      // 自评页需要参数
      selfAssessment: {
        // qType: "assessment",
        // assessmentShow: true,
      },
      loading: false,
      asShow: false,
      setDisabled: true
    };
  },
  methods: {
    interval() {
      /*  计时器
				东八区00：00：00为记时开始时间
			*/
      //1.获得开始时间 开始的毫秒数
      let start_millisecond = -8 * 60 * 60 * 1000;
      let start_time = new Date(start_millisecond);
      //2.获得结束时间 结束的毫秒数
      let end_millisecond = start_millisecond + this.answer_time * 60 * 1000;
      this.count_down = start_time.toTimeString().split(" ")[0];
      //超时时间起始时间
      let out_millisecond = -8 * 60 * 60 * 1000;
      var count_down_timer = setInterval(() => {
        if (start_millisecond <= end_millisecond) {
          start_millisecond = start_millisecond + 1000;
          this.count_down = new Date(start_millisecond)
            .toTimeString()
            .split(" ")[0];
        } else {
          this.out_time = new Date(out_millisecond)
            .toTimeString()
            .split(" ")[0];
          out_millisecond = out_millisecond + 1000;
        }
      }, 1000);
    },
    //初始化试卷
    initPage(qs) {
      let id = this.paper_id;

      this.$HTTP.executeGet(this.$APIS.GET_PAPER_BY_ID + id, this).then(res => {
        this.loading = false
        this.asShow = true
        if (res.msg == "Success!") {
          //获得整个试卷的信息
          let gkpaper = res.data;
          this.paper = gkpaper;
          //获得试卷的考试时间
          //获得所有的题号id
          let qc = 0;
          let order = 1;
          if (gkpaper.gkPapers != undefined) {
            gkpaper.gkPapers.forEach(gp => {
              if(gp.gkBigQuestions != undefined) {
                gp.gkBigQuestions.forEach(gbq => {
                if(gbq.gkQuestions != undefined) {
                  gbq.gkQuestions.forEach(gq => {
                  if (gq.typeCode == "M") {
                    qc += gq.subQuestions.length;
                    gq.subQuestions.forEach(sq => {
                      qs.forEach(item => {
                        if (item.id == sq.id) {
                          this.allscore += sq.score
                          item.order = sq.original;
                          sq.self_answer = item.self_answer;
                          sq.self_score = item.score
                          sq.auditStatus = item.auditStatus
                          sq.correct = item.correct
                          sq.completionStatus = item.status
                          sq.audit_status = item.auditStatus
                        }
                      });
                      sq.questionOrder = order++;
                    });
                  } else {
                    gq.questionOrder = order++;
                    
                    qs.forEach(item => {
                      if (item.id == gq.id) {
                        item.order = gq.original;
                        qc++;
                        gq.self_answer = item.self_answer;
                        gq.self_score = item.score
                        gq.auditStatus = item.auditStatus
                        gq.correct = item.correct
                        this.allscore += gq.score
                      }
                    });
                  }
                });
                }
                
              });
              } 
            });
          }
          if (gkpaper.gkBigQuestions != undefined) {
            gkpaper.gkBigQuestions.forEach(gbq => {
              if(gbq.gkQuestions != undefined) {
                gbq.gkQuestions.forEach(gq => {
                if (gq.typeCode == "M") {
                  qc += gq.subQuestions.length;
                  gq.subQuestions.forEach(sq => {
                    sq.questionOrder = order++;
                    qs.forEach(item => {
                      if (item.id == sq.id) {
                        this.allscore += sq.score
                        item.order = sq.original;
                        sq.self_answer = item.self_answer;
                        sq.self_score = item.score
                        sq.auditStatus = item.auditStatus
                        sq.correct = item.correct
                        sq.completionStatus = item.status
                        sq.audit_status = item.auditStatus

                      }
                    });
                  });
                } else {
                  gq.questionOrder = order++;
                  qc++;
                   
                  qs.forEach(item => {                   
                    
                    if (item.id == gq.id) {
                      this.allscore += gq.score
                      gq.self_score = item.score
                      gq.auditStatus = item.auditStatus
                      gq.correct = item.correct
                      item.order = gq.original;
                      gq.completionStatus = item.status
                      gq.audit_status = item.auditStatus
                      if(item.self_answer!=undefined){
                          
                        let type = gq.typeCode;
                        if(type == 'A' || type == 'C'){
                          gq.self_answer = item.self_answer
                          
                        }
                        if(type == 'B'){
                          let temp = item.self_answer.replace(/\"([A-G])\"/ig,"$1");
                          gq.self_answer = temp.slice(2,temp.length-2).split(",");
                        }
                        if(type == 'C'){

                        }
                        if(type == 'E'){
                            gq.self_answer = item.self_answer
                        }
                        if(type == 'S'){
                            gq.self_answer = item.self_answer
                        }
                        
                      }
                    }
                  });
                }
               
              });
              }
              
            });
          }
          this.questionStatus = qs;
          this.question_num = qc;
          this.interval();

          qs.forEach((item) => {
            this.self_score += item.score;
          });

          
        }
      });
    },

    getTestId() {
      let userInfo = window.localStorage.getItem("userinfo");
      let user = JSON.parse(userInfo);
      const data = {
        test_id: this.$route.query.test_id,
      };
      this.$HTTP
        .executePost(this.$APIS.GET_TEST_BY_TESTDETAIL, data, this)
        .then((res) => {
          if (res.code == 0) {
            //显示app的类型
            let app_id = res.data.typeCode;
            if (app_id == 4) {
              this.app_name = "摸底考试";
            }
            if (app_id == 11) {
              this.app_name = "基础夯实";
            }
            if (app_id == 21) {
              this.app_name = "专题强化";
            }
            if (app_id == 3) {
              this.app_name = "查漏补缺";
            }
            if (app_id == 2) {
              this.app_name = "考前冲刺";
            }
            this.tset_id = res.data.id;
            this.paper_id = res.data.paperId;
            window.localStorage.setItem("test_id", res.data.id);
            let userInfo = window.localStorage.getItem("userinfo");
            let user = JSON.parse(userInfo);
            this.questionSubmitInfo = {
              paper_id: res.data.paperId,
              test_id: res.data.id,
              user_id: user.id,
            };
            // order: sq.original,
            // status: false,
            // correct : false,

            // score : 0,
            // self_answer: '',
            // answer: sq.answer.trimHeadTailTag("p"),
            // id: sq.id,
            // audit_status : false//批改状态
            let arr = res.data.testQuestions;
            let str = JSON.stringify(arr);
            str = str
              .replace(/testId/g, "test_id")
              .replace(/completionStatus/g, "status")
              .replace(/self_answer/g, "answer")
              .replace(/([^\/])answer/g, "$1self_answer")
              .replace(/questionId/g, "id");
            let qs = JSON.parse(str);
            //已经做题的数量
            let count = 0;
            for (let h = 0; h < qs.length; h++) {
              if (qs[h].auditStatus == true || qs[h].audit_status == true) {
                count++;
              }
            }
            this.answer_count = count;
            this.initPage(qs);
            this.answer_time = new Date(res.data.endTime-res.data.startTime).format('hh:mm:ss');
          } else {
            this.$message.error("请求试卷失败!");
          }
        });
    },
  },
  watch: {},
  created() {
    this.model = localStorage.getItem('model')
  },
  mounted() {
    this.loading = true
    this.asShow = false
    this.getTestId();
    //监控答案的改动
    this.$root.eventHub.$on(
      "self-assessment-changed",
      ( original, score, auditStatus, correct ) => {
        //题的状态
        let i = 0;
        for (var j = 0; j < this.questionStatus.length; j++) {
          if (this.questionStatus[j].order == original) {
            i = j;
            break;
          }
        }
        this.questionStatus[i].correct = correct
        this.questionStatus[i].audit_status = auditStatus;
        this.questionStatus[i].score = score;
        //已经做题的数量
        let count = 0;
        for (let h = 0; h < this.questionStatus.length; h++) {
          if (this.questionStatus[h].audit_status == true || this.questionStatus[h].auditStatus == true) {
            count++;
          }
        }
        this.answer_count = count;
        
      }
    );
  },
};
</script>

<style lang="stylus" scoped>
/deep/ .loading_color{
  .el-icon-loading {
    color: #5c307d !important;
    font-size: 60px !important;
  }
  .el-loading-text {
    color: #5c307d !important;
    font-size: 20px !important;
  }
}
.paper_page {
  width: 1920px;
  position: absolute;
  .header_paper {
    width: 1920px;
    height: 81px;
    color: #ffffff;
    background: #5c307d;
    position: fixed;
    z-index: 999;

    .logo_paper {
      width: 150px;
      margin-top: 16px;
      margin-left: 40px;
      float: left;

      img {
        width: 150px;
      }
    }

    .paper_name {
      width: 1774px;
      height: 32px;
      font-size: 32px;
      line-height: 32px;
      text-align: center;
      margin-top: 22px;
      margin-left: -138px;
    }
  }

  .bread {
    width: 1920px;
    height: 70px;
    line-height: 70px;
    font-size: 21px;
    margin-top: 81px;
    background-color: #ffffff;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: #5c307d;
    position: fixed;
    z-index: 999;
    color: #5c307d;

    .first {
      margin-left: 50px;
    }

    div {
      float: left;
      margin-left: 150px;
    }

    span {
      text-align: center;
      float: left;
      font-size: 21px;
      cursor: pointer;
    }

    .text {
      color: #8d8d8d;
    }

    .value {
      color: #5c307d;
    }
  }

  .main {
    width: 1920px;
    position: absolute;
    background-color: #ffffff;
    margin-top: 153px;
    position: relative;
    float: left;

    .paper {
      width: 1563px;
      margin-left: 15px;
      float: left;
      position: absolute;
      background-color: #f5f5f5;
    }

    .aside {
      clear: both;
      width: 300px;
      height: 100%;
      background-color: #f5f5f5;
      margin-left: 1591px;
      position: absolute;
    }
  }
}
</style>